import React from "react";
import styled from "styled-components";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import CancelIcon from "@mui/icons-material/Cancel";

// type StatusBannerType = 'success' | 'error'

const StatusBanner = ({ title, message, type, style }) => {
  return (
    <BannerContainer type={type} style={style}>
      <BannerIcon>
        {type === "success" ? (
          <CheckCircleIcon />
        ) : type === "error" ? (
          <CancelIcon />
        ) : (
          <InfoIcon />
        )}
      </BannerIcon>
      <BannerContent>
        <BannerTitle>{title}</BannerTitle>
        {message && <BannerMessage>{message}</BannerMessage>}
      </BannerContent>
    </BannerContainer>
  );
};

export default StatusBanner;

export const BannerContainer = styled.div`
  background-color: ${({ type }) =>
    type === "success" ? "#D8F5DF" : type === "error" ? "#FEE2D4" : "#DEE2E6"};
  padding: 20px;
  padding: 12px;
  border-radius: 16px;
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
`;

export const BannerIcon = styled.div`
  display: grid;
  place-items: center;
  height: max-content;
`;

export const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const BannerTitle = styled.div`
  font-size: 16px !important;
  line-height: 20px;
  color: #000000;
  font-weight: 500;
`;

export const BannerMessage = styled.div`
  font-size: 14px !important;
  line-height: 20px;
  color: #000000;
  font-weight: 400;
`;
